@if (shops$ | async; as shops) {
  @if (shops.length) {
    <div class="my-2 px-2">
      <div class="mb-2 flex justify-between">
        <h1 class="text-lg font-semibold">Cửa hàng - Nutriday shop</h1>
        <a
          class="btn btn-ghost btn-xs text-sm text-slate-400"
          [routerLink]="['/nutrishop', 'search']">
          Xem thêm
        </a>
      </div>
      <div class="bg-base-200 px-1 py-2">
        <market-carousel-wrapper [options]="options">
          @for (item of shops; track item.id) {
            <li class="splide__slide">
              <a
                class="block cursor-pointer overflow-hidden"
                [routerLink]="['/nutrishop', item.id]">
                <div class="mx-auto w-fit">
                  <img
                    class="h-24 w-24 rounded object-cover"
                    [src]="item.avatar | image"
                    [alt]="item.shopName"
                    marketImageFailed />
                </div>
                <p
                  class="line-clamp-2 max-h-[40px] w-full text-center text-sm font-semibold">
                  {{ item.shopName }}
                </p>
              </a>
            </li>
          }
        </market-carousel-wrapper>
      </div>
    </div>
  }
}
@if (loading()) {
  <market-carousel-categories-skeleton />
}
